import '@styles/style.scss';

document.addEventListener( 'DOMContentLoaded', function() {
  const navArea = document.querySelector('.nav-area');
  const navAreaToggler = document.querySelector('.nav-toggler');
  const navAreaOverlay = document.querySelector('.nav-overlay');
  const bodyClassWhenToggled = 'sidebar--toggled';

  // Return early if the navigation doesn't exist.
  if ( 'undefined' === typeof navArea || 'undefined' === typeof navAreaToggler ) {
    return;
  }

  // Toggle the .nav-area--toggled class each time the button is clicked.
  if (navAreaToggler instanceof HTMLElement) {
    navAreaToggler.addEventListener( 'click', function() {
      toggleState(navAreaToggler, navArea);
    } );
  }

  if ( navAreaOverlay instanceof HTMLElement ) {
    navAreaOverlay.addEventListener( 'click', function(){
      if (document.body.classList.contains( bodyClassWhenToggled ))
        toggleState(navAreaToggler, navArea);
    }, true );
  }

  if ( navArea instanceof HTMLElement ) {
    navArea.querySelectorAll( 'a' ).forEach(link => {
      link.addEventListener( 'click', function(){
        if (document.body.classList.contains( bodyClassWhenToggled ))
          toggleState(navAreaToggler, navArea);
      }, true );
    });
  }

  function toggleState(toggler, targetArea) {
    if (toggler instanceof HTMLElement && targetArea instanceof HTMLElement) {
      toggler.classList.toggle('nav-toggler--toggled' );
      targetArea.classList.toggle('nav-area--toggled' );
  
      document.body.classList.toggle( bodyClassWhenToggled );
  
      if ( toggler.getAttribute( 'aria-expanded' ) === 'true' ) {
        toggler.setAttribute( 'aria-expanded', 'false' );
      } else {
        toggler.setAttribute( 'aria-expanded', 'true' );
      }
    }
  }
});

document.addEventListener( 'DOMContentLoaded', function() {
    /* ------------------- FAB - smooth scroll top ------------------------- */
    const fab = document.querySelector('.fab');
    if (fab instanceof HTMLElement) {
        let fabVisibilityHandler = function() {
          let currentHeight = window.innerHeight || document.documentElement.clientHeight|| document.body.clientHeight;
          if ( window.scrollY > (currentHeight - 52) ) {
            fab.style.visibility = null;
          } else {
            fab.style.visibility = 'hidden';
          }
        }
        fabVisibilityHandler();
        window.addEventListener('scroll', fabVisibilityHandler, false);
        fab.addEventListener('click', function(event){
          window.scrollTo({top: 52, behavior: 'smooth'});
        })
    }

    /* ------------------- Smooth scroll into View ------------------------- */
    document.querySelectorAll('a[href^="#"]:not([href^="#tab"]').forEach(function(link){
      if ( link.hash && document.querySelector( link.hash ) ) {
        link.addEventListener('click', function(event){
          event.preventDefault();
          userScroll = false;
          // let yOffset = -56; // header height 
          let yOffset = 0; // header height 
          let elements = document.querySelectorAll( link.hash );
          let element = null;
          if (elements.length) {
            if ( elements.length == 1 ) {
              element = elements[0];
            } else if ( elements.length  > 1) {
              elements.forEach(el => {
                if (el.offsetParent !== null) {
                  console.log(el);
                  element = el;
                }
              });
            }
          }
          if ( element instanceof HTMLElement ) {
            let y = element.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
          }
        })
      }
    })

    function horizontalNavScrollTo(element) {
      if (element instanceof HTMLElement) {
        documentWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        scrollContainer = element.parentElement;
        scrollContainerWidth = scrollContainer.getBoundingClientRect().width;
        scrollContainer.style.width = documentWidth * ( (scrollContainerWidth / documentWidth) - (scrollContainerWidth % documentWidth) + 1);
        scrollContainerWidth = scrollContainer.getBoundingClientRect().width;
        // if container width not even viewports width
        // if ( ( scrollContainerWidth % documentWidth ) > (documentWidth * 0.67) )  {
        //   // scrollContainer.style.width = scrollContainerWidth + ( documentWidth - ( scrollContainerWidth % documentWidth ) )
        //   scrollContainerWidth = scrollContainer.getBoundingClientRect().width;
        // }

        scrollContainer.scrollTo({
          left: element.offsetLeft,
          behavior: 'smooth'
        });

        // console.log("L: %s, R: %s, PL: %s, PR: %s DOCUMENT W: %s", element.getBoundingClientRect().left, element.getBoundingClientRect().right, scrollContainer.scrollLeft, scrollContainer.scrollRight, documentWidth)
        // console.log(element.getBoundingClientRect().top, window.scrollY, yOffset)
      }
    }
    /* ------------------- JS Tabs Nav ------------------------- */
    let tabsClass = 'tabs';
    let tabsNavItemClass = tabsClass + '__nav-item';
    let tabsNavItemActiveClass = tabsNavItemClass + '--active';
    let tabsNavPaneClass = tabsClass + '__pane';
    let tabsNavPaneActiveClass = tabsNavPaneClass + '--active';

    const navTabs = document.querySelectorAll('.' + tabsClass);
    if ( navTabs) {
      navTabs.forEach(function(navTab){
        const navTabsItems = navTab.querySelectorAll('.' + tabsNavItemClass);

        function navTabActivate(event) {
          event.preventDefault();
          let clickedTab = event.target;

          // prevent unneded changes
          if ( !clickedTab.classList.contains( tabsNavItemActiveClass ) ) {

            // dispatch event
            window.dispatchEvent(
              new CustomEvent("tabswitch", {
                bubbles: true,
                detail: { tabId: () => clickedTab.dataset?.tabId },
            }));

            for (let i = 0; i < navTabsItems.length; i++) {
              if (navTabsItems[i].dataset.tabId == clickedTab.dataset?.tabId) {
                navTabsItems[i].classList.add(tabsNavItemActiveClass);
              } else {
                navTabsItems[i].classList.remove(tabsNavItemActiveClass);
              }
            }
    
            let tabContentPanes = navTab.querySelectorAll('.' + tabsNavPaneClass);
            for (i = 0; i < tabContentPanes.length; i++) {
                tabContentPanes[i].classList.remove(tabsNavPaneActiveClass);
            }
  
            let tabContentPaneId = clickedTab.dataset?.tabId;
            let tabContentPane = navTab.querySelector('#' + tabContentPaneId);
            if (tabContentPane instanceof HTMLElement) {
              tabContentPane.classList.add(tabsNavPaneActiveClass);
            } else {
              console.warn('Nav: tab pane not found');
            }
  
            /* Update */
            try {
              let tabPosition = clickedTab.getBoundingClientRect().top + window.scrollY;
              let tabPanePosition = tabContentPane.getBoundingClientRect().top + window.scrollY;
              if (tabPosition > tabPanePosition) {
                window.scrollTo({top: tabPanePosition, behavior: 'smooth'});
              }
            } catch (error) {
              console.warn('Tab navigation error');
            }

          }
          
        }
        
        if ( navTabsItems ) {
          for (i = 0; i < navTabsItems.length; i++) {
              navTabsItems[i].addEventListener("click", navTabActivate)
          }
        }
      })
    }


    /* ------------------- Sticky Nav Menu ------------------------- */
    var stickyStartPos = -1;
    const ezqrNavBars = document.querySelectorAll('.js-ez-menu-nav');
    
    function findPositionY(element) {
      let currentTop = 0;
      if ( element.offsetParent !== null && element.offsetParent ) {
        while (element.offsetParent) {
          currentTop += element.offsetTop;
          element = element.offsetParent;
        }
        currentTop += element.offsetTop;
      } else if (element.y) {
        currentTop += element.y;
      }
      return currentTop;
    }

    let navigationScrollingHandler = function(){
      ezqrNavBars.forEach(ezqrNavBar => {
        if (stickyStartPos < 0) {
          stickyStartPos = findPositionY(ezqrNavBar);
        }
        if (window.scrollY > stickyStartPos) {
          ezqrNavBar.classList.add("ez-menu-nav--sticky");
        } else {
          ezqrNavBar.classList.remove("ez-menu-nav--sticky");
        }
      });
    };

    ['scroll', 'resize','tabswitch'].forEach(function(e){
      window.addEventListener(e, navigationScrollingHandler, false);
    });

  /* Global set navigation sliders */
  window.ezqr = {
    nav: {}
  }

  /* ------------------- Splide menu navigation ------------------------- */
  if ( window['Splide'] ) {
    const spliders = document.querySelectorAll('.js-ez-menu-nav .splide');
    spliders.forEach(splider => {

      let currentNavElementsCount = splider.querySelectorAll('.splide__list .splide__slide').length
      const SPLIDE_MIN_ELEMENTS = 4;

      let clonesCount = (SPLIDE_MIN_ELEMENTS - currentNavElementsCount) > 0 ? 0 : 2;
      clonesCount = 0;
      let menuNavCarousel = new Splide( splider, {
        clones : 0,
        type   : 'loop',
        clones : clonesCount,
        rewind : true,
        focus  : 0,
        speed  : 330,
        drag   : true,
        gap    : '10px',
        omitEnd : true,
        autoplay : false,
        mediaQuery : 'min',
        pagination : false,
        trimSpace: false,
        autoHeight : true,
        updateOnMove: true,
      }
    );
    
    /* Updates the bar width whenever the carousel moves */
    let progressbar = menuNavCarousel.root.querySelector( '.splide__progress-bar' );
    if (progressbar) {
      menuNavCarousel.on( 'mounted move', function () {
        var end  = menuNavCarousel.Components.Controller.getEnd() + 1;
        var rate = Math.min( ( menuNavCarousel.index + 1 ) / end, 1 );
        progressbar.style.width = String( 100 * rate ) + '%';
      } );
    }
    
    /* Move carousel when slide clicked */
    menuNavCarousel.on( 'click', function (Slide, e) {
        menuNavCarousel.go(Slide.index);
    });
    
    /* Mount carousel element */
    menuNavCarousel.mount();

      /* Add to global navs list */
      if (splider.dataset?.superset) window.ezqr.nav[splider.dataset?.superset] = menuNavCarousel;

    /* Callback that Activate CurrentElement */
    // function menuActivateCurrentItem( carouselElement ) {
    //   if (!carouselElement)
    //     return;

    //   currentSlide = carouselElement.Components.Slides.getAt( carouselElement.index );
    //   currentSlideElement = currentSlide.slide;
    //   if ( currentSlideElement ) {
    //     let innerNavLink = currentSlideElement.querySelector('a');
    //     if (innerNavLink) innerNavLink.click();
    //   }
    // }

    /* // Add arrows click on-page navigation
    [ menuNavCarousel.Components.Arrows.arrows.prev, menuNavCarousel.Components.Arrows.arrows.next ].forEach(function(arrow){
      arrow.addEventListener('click', function() { menuActivateCurrentItem(menuNavCarousel) }, false);
    }); */

    })

  } else {
    console.warn('Splide: not detected, remove unused classes');
    document.querySelectorAll('.splide').forEach(splider => {
      splider.classList.remove('splide');
    })
  }

  /* ------------------- Change state of items in navigation bar on scroll ------------------------- */
  const categories = document.querySelectorAll('.ez-menu-category');
  const supersets = document.querySelectorAll('.ez-menu-superset');

  supersets.forEach(s => {
    if (s.parentElement.parentElement.classList.contains('tabs__pane--active')) {
      s.classList.add('is-active')
    }
  });

  let topActivatePosition = 96;
  let bottomDeactivatePosition = topActivatePosition; //120;

  // let next = null;
  // let current = null;
  // let prev = null;
  window.addEventListener('scroll', function(){
    // for(let i = 0; i < supersets.length; i++) {
    //   let currentNavBar = supersets[i].querySelector('.js-ez-menu-nav');
    //   let supersetRectangle = supersets[i].getBoundingClientRect();
    //   if ( supersetRectangle.top < topActivatePosition && supersetRectangle.bottom > bottomDeactivatePosition ) {
    //     if ( !supersets[i].classList.contains('is-active') ) {
    //       supersets[i].classList.add('is-active');
    //       currentNavBar.classList.add('is-active');
    //       next = supersets[i+1];
    //       current = supersets[i]
    //       prev = supersets[i-1];
    //     }
    //   } else {
    //     supersets[i].classList.remove('is-active')
    //     currentNavBar.classList.remove('is-active');
    //   }
    // }

    categories.forEach(category => {
      let supersetId = category.dataset.superset;
      let supersetNav = supersetId != undefined && window.ezqr.nav[supersetId] != undefined ? window.ezqr.nav[supersetId] : '';
      let index = category.dataset?.index != undefined ? parseInt(category.dataset?.index, 10): undefined;

      // console.log(supersetId, supersetNav, index);

      let sectionClientRect = category.getBoundingClientRect();
      if ( sectionClientRect.top < topActivatePosition && sectionClientRect.bottom > bottomDeactivatePosition ) {
        // TODO: track active state
        if ( !category.classList.contains('is-active') ) {
          category.classList.add('is-active')
          // console.log(supersetNav.index, index);
          if ( supersetId != undefined && index != undefined && supersetNav != undefined) {
            if ( supersetNav.index != index) {
              supersetNav.go(index);
            }
          }
        }
      } else {
        category.classList.remove('is-active')
      }
    });

  }, false);

  /* Pseudo-React createElement Function */
    const React = {
        createElement: function (tag, attrs, children) {
            var element = document.createElement(tag);

            for (let name in attrs) {
                if (name && attrs.hasOwnProperty(name)) {
                    let value = attrs[name];
                    if (value === true) {
                        element.setAttribute(name, name);
                    } else if (value !== false && value != null) {
                        element.setAttribute(name, value.toString());
                    }
                }
            }
            for (let i = 2; i < arguments.length; i++) {
                let child = arguments[i];
                element.appendChild(
                    child.nodeType == null ?
                        document.createTextNode(child.toString()) : child);
            }
            return element;
        }
    };

    /* Create Dish Popup Content */
    document.querySelectorAll('.ez-item__thumb').forEach(ezItemImage => {
      ezItemImage.addEventListener('click', function(){

        console.log( createPopup(this.closest('.ez-item')) );
        
      })
    });

    function createPopup( targetElement, popupClass = 'popup', ) {
      // remove old popup if exists
      let popup = document.querySelector('.' + popupClass);
      if ( popup instanceof HTMLElement) popup.remove();

      /* Base structure section */
      popupContent = React.createElement("div", {class: popupClass + '__content'});
      popupClose = React.createElement("div", {class: popupClass + '__close'});
      popupInner = React.createElement("div", {class: popupClass + '__inner'}, popupClose, popupContent ),
      popup = React.createElement("div", {class: popupClass}, popupInner );

      /* Create content */
      if ( targetElement instanceof HTMLElement ) {
        let dishName = targetElement.querySelector('.ez-item__name');
        let dishImage = targetElement.querySelector('.ez-item__thumb');
        let dishDesc = targetElement.querySelector('.ez-item__desc');
        let dishPrice = targetElement.querySelector('.price');

        if (dishName instanceof HTMLElement) {
          popupContent.appendChild(dishName.cloneNode(true));
        }
        if (dishDesc instanceof HTMLElement) {
          popupContent.appendChild(dishDesc.cloneNode(true));


          let readmoreComponent = document.getElementById('component-readmore');
          if (readmoreComponent instanceof HTMLTemplateElement) {
            popupContent.appendChild( readmoreComponent.content.cloneNode(true) );
            let readmore = popupContent.querySelector('.readmore');

            readmore.addEventListener('click', function(event){
              popupContent.classList.toggle(popupClass + '__content' + '--toggled')
              readmore.classList.toggle('readmore' + '--toggled')
            });
          }
        }
        if (dishPrice instanceof HTMLElement) {
          popupContent.appendChild(dishPrice.cloneNode(true));
        }
        if (dishImage instanceof HTMLElement) {
          popupInner.appendChild(dishImage.querySelector('picture').cloneNode(true));              
        }

        /* Close and remove popup function */
        let destroy = function(){
          popup.classList.toggle( popupClass + '--created');
          setTimeout(function(){
            popup.remove()
          }, 150)
        }

        /* Toggle function */
        let create = function(){
          setTimeout(function(){
            popup.classList.toggle( popupClass + '--created');
          }, 150);
        }

        create();

        /* Destroy variants */
        popupClose.addEventListener('click', destroy);
        document.addEventListener('scroll', destroy);
        window.addEventListener('resize', destroy);
        popup.addEventListener('click', function(event){
          if (event.target === event.currentTarget) {
            destroy();
          };
        }, false);

        /* Attach to document */
        document.body.appendChild(popup);
        return popup;
      }

    }

} );